import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import { getAllData, getData, getDataByPara, postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import { decryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import { loaderActions } from "../../../../_actions/loader.actions";
import { calculateDifference } from "../../../../components/commonClass/CommonValidation";
import { AirDataObjects } from "./FlightSeatsEnum";
import FlightAddTravellerForm from "./FlightAddTravellerForm";
import FlightPayment from "./FlightPayment";
import { updateActions } from "../../../../_actions/user.action";
import { fetchIp, getupdatedflightdetails } from "../../../../components/commonClass/CommonFunctions";
import FlightBookingConfirmation from "../../BookingConfirmScreen/Flights/FlightBookingConfirmation";


const FlightDetails = () => {
    // Passenger Type Adult – 1 Child – 2 Infant – 3
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [flightFareQouteData, setFlightFareQouteData] = useState<any[]>([]);
    const [flightFareRuleData, setFlightFareRuleData] = useState([]);
    const [dropdownData, setDropdownData] = useState({
        travellerList: [],
        countryList: [],
        cityList: [],
    });
    const [flightSsrData, setFlightSsrData] = useState({});
    const [passengersData, setPassengersData] = useState([]);
    const [otherData, setOtherData] = useState([]);
    const [markupAndConvenienceDetail, setMarkupAndConvenienceDetail] = useState([]);
    const APIBadMessage = 'Something went wrong, Please try again!'

    const [updatedFlightDetailsData, setUpdatedFlightDetailsData] = useState<any>(null);


    const isDomeRtnData = sessionStorage.getItem('isDomRtn');
    const isDomRtn = isDomeRtnData ? JSON.parse(isDomeRtnData) : 0;

    const isinternationalData = sessionStorage.getItem('isinternational');
    const isInternational = isinternationalData ? JSON.parse(isinternationalData) : false;

    const checkPathName = useMemo(() => {
        return (location?.pathname?.includes('review') || location?.pathname?.includes('payment')) ? true : false;
    }, [location])

    const RedirectToFllightListScreen = () => {
        const params = new URLSearchParams(searchParams);
        params.delete("tId");
        params.delete("rIndex");

        return '/flights/search?' + params.toString()
    }


    const callUpdatedFlightDetailsDataAPI = async () => {
        const updatedflightdetails =
            flightFareQouteData?.[isDomRtn]?.response?.journeyTypeId === 2 && !isInternational ?
                await getupdatedflightdetails(
                    decryptUrlDatapattern(location?.state?.BookingId)?.[1] || 0,
                    decryptUrlDatapattern(location?.state?.BookingId)?.[0] || 0
                )
                :
                await getupdatedflightdetails(
                    decryptUrlDatapattern(location?.state?.BookingId)?.[0] || 0,
                    decryptUrlDatapattern(location?.state?.BookingId)?.[1] || 0
                )

        if (updatedflightdetails === null) {
            dispatch({ type: 'ALERTING', message: APIBadMessage, path: RedirectToFllightListScreen() });
            dispatch(loaderActions.end());
            return;
        }
        else {
            setUpdatedFlightDetailsData(updatedflightdetails);
        }
        dispatch(updateActions.updatedclear());
    }


    const getflightfare = async (data: any) => {
        let userData: any = GetLocalStorage();

        // Flight fare rule data
        const flightfarerule = await getDataByPara('/customerui/v1/getflightfarerule', data)
        if (flightfarerule?.status) {
            setFlightFareRuleData(flightfarerule?.data);

            // Holidays → Manage Traveller List data
            const travellerlistbyid = await getAllData(`/midoffice/v1/gettravelerprofilelist`)
            if (travellerlistbyid?.status) {
                setDropdownData((data) => ({
                    ...data,
                    travellerList: travellerlistbyid?.data?.filter((el: any) => el.UserName?.trim()?.length > 0),
                }))
            }
            else {
                dispatch({ type: 'ALERTING', message: travellerlistbyid?.message || APIBadMessage, path: RedirectToFllightListScreen() });
                dispatch(loaderActions.end());
                return;
            }

            // dropdown data
            const territorydetails = await getData(`/customerui/v1/getterritorydetails`)
            if (territorydetails?.status) {
                setDropdownData((data) => ({
                    ...data,
                    countryList: territorydetails?.data?.countryList,
                }))
            }
            else {
                dispatch({ type: 'ALERTING', message: territorydetails?.message || APIBadMessage, path: RedirectToFllightListScreen() });
                dispatch(loaderActions.end());
                return;
            }


            const flightuiconfigurations = await getAllData('/customerui/v1/getflightuiconfigurations')
            if (flightuiconfigurations?.status) {
                setDropdownData((data) => ({
                    ...data,
                    cityList: flightuiconfigurations?.data?.cityList,
                }))
            }
            else {
                dispatch({ type: 'ALERTING', message: territorydetails?.message || APIBadMessage, path: RedirectToFllightListScreen() });
                dispatch(loaderActions.end());
                return;
            }

            // markup and convinience fee data
            const getmarkupdetailsbytravelcategoryid = await getAllData(`/customerui/v1/getmarkupdetailsbytravelcategoryid?travelCategoryId=${1}`)
            if (getmarkupdetailsbytravelcategoryid?.status) {
                setMarkupAndConvenienceDetail(getmarkupdetailsbytravelcategoryid?.data)
            }
            else {
                dispatch({ type: 'ALERTING', message: getmarkupdetailsbytravelcategoryid?.message || APIBadMessage, path: RedirectToFllightListScreen() });
                dispatch(loaderActions.end());
                return;
            }


            // Flight fare quote data
            let objdata: any[] = []
            let fareQuotefailed: any[] = [];

            // only for domestic return flight → get data of Out-Bound flight (which is booked) from API(from database) for displaying.
            if (isDomRtn === 1) {
                const updatedflightdetails = await getupdatedflightdetails(
                    decryptUrlDatapattern(location?.state?.BookingId)?.[0] || 0,
                    decryptUrlDatapattern(location?.state?.BookingId)?.[1] || 0
                )
                if (updatedflightdetails === null) {
                    dispatch({ type: 'ALERTING', message: APIBadMessage, path: RedirectToFllightListScreen() });
                    dispatch(loaderActions.end());
                    return;
                }
                else {
                    updatedflightdetails?.fareQoute?.[0]?.response?.results?.segments?.map((seg: any) => {
                        seg.flightFromTo = `${seg?.[0]?.origin?.airport?.cityName || ""} - ${seg?.[seg?.length - 1]?.destination?.airport?.cityName || ""}`
                        seg.totalFlightTime = calculateDifference(seg?.[0]?.origin?.depTime, seg?.[seg?.length - 1]?.destination?.arrTime)

                        seg?.map((obj: any, index: number, arr: any) => {
                            obj.flightDuration = calculateDifference(obj?.origin?.depTime, obj?.destination?.arrTime)
                            obj.layover = calculateDifference(arr?.[index]?.destination?.arrTime, arr?.[index + 1]?.origin?.depTime)
                            return obj;
                        })
                        return seg;
                    })

                    objdata = [...objdata, updatedflightdetails?.fareQoute?.[0]];
                }
            }

            const rIndex = decryptUrlDatapattern(searchParams.get('rIndex'))
            const indexVal = isDomRtn === 1 ? 1 : 0; //set first value of index is isDomRtn. So, loop is run only once when book for In-Bound flight for domestic return otherwise run as normal.
            for (let index = indexVal; index < rIndex?.length; index++) {
                dispatch(loaderActions.start());
                const fltbookid = decryptUrlDatapattern(location?.state?.BookingId)?.[index]
                const fareQuotePayload = {
                    EndUserIp: data?.EndUserIp,
                    TraceId: decryptUrlDatapattern(searchParams.get('tId')),
                    ResultIndex: rIndex?.[index],
                    FlightBookingId: fltbookid || 0,
                    UserId: userData?.userMasterID || 0
                }
                const flightfareqoute = await getDataByPara('/customerui/v1/getflightfareqoute', fareQuotePayload);
                if (flightfareqoute?.status) {
                    if (isDomRtn === index && (flightfareqoute?.data?.response?.isPriceChanged || false)) {
                        const travellerBookingData = {
                            flightBookingId: fltbookid || 0,
                            baseFare: flightfareqoute?.data?.response?.results?.fare?.baseFare || 0,
                            tax: flightfareqoute?.data?.response?.results?.fare?.totalTaxAndSurcharges || 0,
                            finalValue: flightfareqoute?.data?.response?.results?.fare?.grandTotal || 0,
                            userId: userData?.userMasterID || 0
                        }
                        const insertflighttravellerbooking = await postUsersData('/customerui/v1/insertflighttravellerbooking', travellerBookingData);
                        if (!insertflighttravellerbooking?.status) {
                            dispatch({ type: 'ALERTING', message: insertflighttravellerbooking?.message || APIBadMessage, path: RedirectToFllightListScreen() });
                            dispatch(loaderActions.end());
                        }
                    }

                    if (flightfareqoute?.data?.response?.results?.segments?.length > 0) {
                        flightfareqoute?.data?.response?.results?.segments?.map((seg: any) => {
                            seg.flightFromTo = `${seg?.[0]?.origin?.airport?.cityName || ""} - ${seg?.[seg?.length - 1]?.destination?.airport?.cityName || ""}`
                            seg.totalFlightTime = calculateDifference(seg?.[0]?.origin?.depTime, seg?.[seg?.length - 1]?.destination?.arrTime)

                            seg?.map((obj: any, index: number, arr: any) => {
                                obj.flightDuration = calculateDifference(obj?.origin?.depTime, obj?.destination?.arrTime)
                                obj.layover = calculateDifference(arr?.[index]?.destination?.arrTime, arr?.[index + 1]?.origin?.depTime)
                                return obj;
                            })
                            return seg;
                        })
                        objdata = [...objdata, flightfareqoute?.data]
                        setFlightFareQouteData(objdata);
                    }
                }
                else {
                    fareQuotefailed = [...fareQuotefailed, flightfareqoute];
                    const message = fareQuotefailed?.map((item) => item?.message)?.join(" | ");
                    dispatch({ type: 'ALERTING', message: message || APIBadMessage, path: RedirectToFllightListScreen() });
                    dispatch(loaderActions.end());
                }
            }


            // Flight SSR data
            const flightssrdetails = await getDataByPara('/customerui/v1/getflightssrdetails', data)
            if (flightssrdetails?.status) {
                flightssrdetails?.data?.response?.baggage?.map((baggage: any) => {
                    baggage?.forEach((bag: any) => {
                        bag['paxType'] = [];
                    })
                    return baggage;
                })
                flightssrdetails?.data?.response?.mealDynamic?.map((mealDynamic: any) => {
                    mealDynamic?.forEach((meal: any) => {
                        meal['paxType'] = [];
                    })
                    return mealDynamic;
                })
                flightssrdetails?.data?.response?.seatDynamic?.map((seatDynamic: any) => {
                    seatDynamic?.segmentSeat?.map((row: any) => {
                        row?.rowSeats?.map((seatColl: any) => {
                            seatColl?.seats?.forEach((seat: any, index: number, arr: any) => {
                                seat['paxType'] = "";
                                seat.DescriptionName = AirDataObjects.Description[seat?.description];
                                seat.WayTypeName = AirDataObjects.WayType[seat?.seatWayType];
                                seat.SeatAvailalblityTypeName = AirDataObjects.SeatAvailalblityType[seat?.availablityType];
                                seat.SeatTypeName = AirDataObjects.SeatType[seat?.seatType];
                                seat.DeckName = AirDataObjects.Deck[seat?.deck];
                                seat.CompartmentTypeName = AirDataObjects.CompartmentType[seat?.compartment];

                                if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing") && arr?.[index - 1] === undefined) {
                                    seat.classes = ['windowrow', 'leftWing']
                                }
                                else if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing") && arr?.[index + 1] === undefined) {
                                    seat.classes = ['windowrow', 'rightWing']
                                }
                                else if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing")) {
                                    seat.classes = ['windowrow']
                                }

                            })
                            return seatColl;
                        })
                        return row;
                    })
                    return seatDynamic;
                })
                setFlightSsrData(flightssrdetails?.data);
            }

            if ((objdata !== null || objdata !== undefined) && objdata?.length > 0) {
                callUpdatedFlightDetailsDataAPI();
            }

        }
        else {
            dispatch({ type: 'ALERTING', message: flightfarerule?.message || APIBadMessage, path: RedirectToFllightListScreen() });
            dispatch(loaderActions.end());
            return;
        }

    }

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                if (location?.state !== null && location?.state?.BookingId !== undefined) {
                    let userip = await fetchIp();
                    if (userip?.status) {
                        const data = {
                            EndUserIp: userip?.data,
                            TraceId: decryptUrlDatapattern(searchParams.get('tId')),
                            ResultIndex: decryptUrlDatapattern(searchParams.get('rIndex'))?.[isDomRtn],
                            FlightBookingId: (decryptUrlDatapattern(location?.state?.BookingId))?.[isDomRtn]
                        };
                        if (checkPathName && location?.state?.isRetryPayment !== true) {
                            dispatch(loaderActions.start());
                            await Promise.all([
                                getflightfare(data)
                            ])
                        }
                        dispatch(loaderActions.end());
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: APIBadMessage, path: RedirectToFllightListScreen() });
                        dispatch(loaderActions.end());
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: APIBadMessage, path: RedirectToFllightListScreen() });
                    dispatch(loaderActions.end());
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
        fetchData();
    }, [])

    const handlePage = (name: any) => {
        const newSearchParams = new URLSearchParams(searchParams);
        navigate({ pathname: `/flight/` + name, search: newSearchParams.toString() }, { state: location?.state })
    }

    const UpdatedBookFlightData = (isDomRtn: any) => {
        return isDomRtn === 0 ? updatedFlightDetailsData?.bookingResponse?.[0] : updatedFlightDetailsData?.bookingResponse?.[1];
    }

    return (
        <>
            <section className={`${checkPathName ? 'midSection' : ''} `}>
                <div className={` ${checkPathName ? 'container' : ''}`}>
                    {
                        checkPathName &&

                        <ul className="breadcrumb mb-3">

                            <li className={` 
                                ${(location?.pathname?.includes('review') || location?.pathname?.includes('payment')) ? 'active' : ''}`}
                            >
                                <button type='button' className='btn p-0' onClick={() => handlePage('review')} >Review</button>
                            </li>
                            <li className={` ${location?.pathname?.includes('payment') ? 'active' : ''}`} >
                                <div>Payment</div>
                            </li>
                        </ul>
                    }

                    <Routes>
                        {/* <Route path="review" element={
                            <div className="row">
                                <div className="detailContainer">
                                    {flightFareQouteData && <FlightReviewComponant flightData={flightFareQouteData} isDomRtn={isDomRtn} flightFareRuleData={flightFareRuleData} />}
                                </div>

                                <div className="rightSec">
                                    <div className="holidayPriceSummary">
                                        <PriceSummary
                                            adultPrice={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 1)?.baseFare}
                                            adultCount={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 1)?.passengerCount}
                                            childPrice={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 2)?.baseFare}
                                            childCount={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 2)?.passengerCount}
                                            infantPrice={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 3)?.baseFare}
                                            infantCount={flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.find(fin => fin?.passengerType === 3)?.passengerCount}
                                            taxValue={flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.totalTaxAndSurcharges}
                                            otherValue={flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.otherCharges}
                                            finalValue={flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.grandTotal}
                                        />
                                        <button type='button' className="btn continueBtn" onClick={() => handlePage('travellers')} >Continue</button>
                                    </div>

                                </div>
                            </div>
                        } /> */}
                        <Route path="review" element={
                            <FlightAddTravellerForm
                                flightFareQouteData={flightFareQouteData}
                                flightFareRuleData={flightFareRuleData}
                                dropdownData={dropdownData}
                                isDomRtn={isDomRtn}
                                setPassengersData={setPassengersData}
                                setOtherData={setOtherData}
                                UpdatedBookFlightData={UpdatedBookFlightData}
                            />
                        } />
                        <Route path="payment" element={
                            <FlightPayment
                                isDomRtn={isDomRtn}
                                flightFareQouteData={flightFareQouteData}
                                flightFareRuleData={flightFareRuleData}
                                passengersData={passengersData}
                                otherData={otherData}
                                flightSsrData={flightSsrData}
                                markupAndConvenienceDetail={markupAndConvenienceDetail}
                                UpdatedBookFlightData={UpdatedBookFlightData}
                                onFlightDataUpdate={callUpdatedFlightDetailsDataAPI}
                            />
                        } />

                    </Routes>
                </div>
            </section>
            <Routes>
                <Route path="in-process" element={<FlightBookingConfirmation />} />
                <Route path="failed" element={<FlightBookingConfirmation />} />
                <Route path="pending" element={<FlightBookingConfirmation />} />
            </Routes>
        </>
    )
}

export default FlightDetails